import axios from 'axios';

// Isolated axios instance for the assessor portal so its token never collides
// with the admin session's default Authorization header (both can be open
// in the same browser at once).
const assessorApi = axios.create();

assessorApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('assessorToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default assessorApi;
